var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btnAssStyle" },
    [
      _vm.type === 1
        ? _c(
            "van-button",
            {
              attrs: { round: "", size: "small", disabled: _vm.disabled },
              on: { click: _vm.clickBtn }
            },
            [_vm._v(_vm._s(_vm.text))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === 2
        ? _c(
            "van-button",
            {
              staticClass: "redButton",
              attrs: { round: "", size: "small" },
              on: { click: _vm.clickBtn }
            },
            [_vm._v(_vm._s(_vm.text))]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }